import React from 'react'
import Layout from './Layout'
import AnnouncementManager from './AnnouncementManager'

const AnnouncementManagerPage = () => {
    return (
        <Layout>
            <AnnouncementManager />
        </Layout>
    )
}

export default AnnouncementManagerPage